import React, { useState } from 'react';
import { Image } from 'react-bootstrap';
import PowerShadesTypeahead from '../Parts/PowerShadesTypeahead';
import { useQuoteById } from '../Store/entities/quotes/hooks';
import { useDealerById, useDealers } from '../Store/entities/hooks';
import { UsePortalDispatch } from '../Store';
import { updateQuoteDealerId } from '../Store/entities/quotes';
import { useDealerTiers } from '../Store/entities/organizations/dealerTiers';

const DealerAssign = ({
	quoteId,
	className = '',
	extraMargin = false,
	showDealerTier = true
}) => {
	const quote = useQuoteById(quoteId);
	const dealerId = quote.dealer_id ?? 0;
	const dispatch = UsePortalDispatch();

	const editable = quote.editable ?? false;
	const [imageError, setImageError] = useState(false);

	const dealer = useDealerById(dealerId);
	const dealers = useDealers();

	const [loadingDealers] = useState(false);

	const dealerTiers = useDealerTiers();
	const dealerTier = dealerTiers.tiers.find((tier) => tier.id === (dealer?.dealer_tier_id ?? 1));
	
	const imageUrl = `${process.env.BACKEND_ROOT}/api/DealerTiers/${dealer?.dealer_tier_id}/Portrait`;

	const changedDealers = (newDealer) => {
		const workingDealer = newDealer[0] ?? { label: 'Removed', value: 0 };
		
		dispatch(updateQuoteDealerId({
			quoteId,
			dealerId: workingDealer.value
		}));
	};

	const options = dealers
		.filter((d) => d.status === 'approved' && d.territory_ids.includes(quote?.territory_id ?? 0))
		.map((d) => ({ label: d.name, value: d.id }))
		.sort((s1, s2) => s1.label.localeCompare(s2.label));

	const currentDealer = dealer;

	const transformedDealer = currentDealer
		? { label: currentDealer.name, value: currentDealer.id }
		: { label: '', value: 0 };

	return (
		<div className={`${className} ${extraMargin ? 'mb-1' : null}`}>
			<label htmlFor="dealer-typeahead" className={extraMargin ? 'mb-1' : ''}>Dealer</label>
			<br />
			<PowerShadesTypeahead
				clearButton
				id='dealer-typeahead'
				key={options.length}
				options={options}
				selected={currentDealer ? [transformedDealer] : []}
				onChange={(newDealer) => changedDealers(newDealer)}
				disabled={!editable}
				placeholder={loadingDealers ? 'Loading...' : 'Assign a Dealer'}
			/>
			{showDealerTier && !imageError && (
				<Image
					fluid
					src={imageUrl}
					alt={dealerTier?.name}
					style={{ height: "50px" }}
					onError={() => setImageError(true)}
					onLoad={() => setImageError(false)}
				/>
			)}
		</div>
	);
};

export default DealerAssign;
